import styled from "styled-components";
export default function NotSetDisplay(props: { text?: string }) {
  return <Italic>{props.text ?? "Not Set"}</Italic>;
}
const Italic = styled.i`
  color: #aaa;
`;
